import { useState, useEffect, useRef, useContext } from "react";
import uplaodIcon from "../../assets/upload-green-icon.svg";
import calenderIcon from "../../assets/calender-icon.svg";
import timeIcon from "../../assets/time-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import saveIcon from "../../assets/save-icon.svg";
import { CaseStageContext } from "../../dashboard/cases/contexts/CaseContexts";
import { toast } from "react-toastify";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { CaseServices } from "../../services/CaseServices";
import { useLocation } from "react-router-dom";
const AdmissionDetailsForm = ({ data, caseStage, saveAll }) => {
  const { caseDetails, fetchCaseDetails } = useContext(CaseStageContext);
  const [admissionDate, setAdmissionDate] = useState("");
  const [admissionTime, setAdmissionTime] = useState("");
  const [dischargeDate, setDischargeDate] = useState("");
  const [admissionType, setAdmissionType] = useState("");
  const [medicoLegalCase, setMedicoLegalCase] = useState("No");
  const [incidentDate, setIncidentDate] = useState("");
  const [firDate, setFirDate] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [description, setDescription] = useState("");
  const [firReport, setFirReport] = useState(null);
  const [superintendentDeclaration, setSuperintendentDeclaration] =
    useState(null);
  const admissionTypeOptions = ["PLANNED", "EMERGENCY"];
  const [isEditMode, setIsEditMode] = useState(false);
  const admissionDateRef = useRef(null);
  const incidentDateRef = useRef(null);
  const firDateRef = useRef(null);
  const surgeryTreatmentDateRef = useRef(null);
  const location = useLocation();
  const getMinDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 2); // today counts as day 1, so go back 2 more days
    return date.toISOString().split("T")[0];
  };

  const getMaxDate = () => {
    return new Date().toISOString().split("T")[0]; // today
  };

  function extractISTTimeFromUTC(utcDateStr) {
    if (!utcDateStr) return "";

    const date = new Date(utcDateStr);
    if (isNaN(date.getTime())) return "";

    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    const parts = formatter.formatToParts(date).reduce((acc, p) => {
      acc[p.type] = p.value;
      return acc;
    }, {});

    return `${parts.hour}:${parts.minute}`;
  }
  function convertISTtoUTC(dateStr, timeStr = "00:00") {
    let year, month, day;

    if (dateStr.includes("-")) {
      // YYYY-MM-DD
      [year, month, day] = dateStr.split("-").map(Number);
    } else if (dateStr.includes("/")) {
      // DD/MM/YYYY
      const parts = dateStr.split("/").map(Number);
      day = parts[0];
      month = parts[1];
      year = parts[2];
    } else {
      throw new Error("Unrecognized date format: " + dateStr);
    }

    let [hours, minutes, seconds = 0] = timeStr.split(":").map(Number);
    const asUTC = Date.UTC(year, month - 1, day, hours, minutes, seconds);
    // Subtract IST offset (5 hours 30 minutes) to get the real UTC instant
    const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;
    const utcDate = new Date(asUTC - IST_OFFSET_MS);

    return utcDate.toISOString();
  }

  const handleUpdate = async () => {
    const modifiedDate = convertISTtoUTC(admissionDate, admissionTime);
    const mdifiedSurgeryDate = dischargeDate && convertISTtoUTC(dischargeDate);
    if (!dischargeDate) {
      toast.error("Surgery Treatment Date is required.");
      return;
    }
    console.log("dischargeDate", dischargeDate);

    try {
      await CaseServices.updateCase(
        {
          admissionDate: modifiedDate,
          surgeryTreatmentStartDate: mdifiedSurgeryDate,
          admissionType: admissionType,
          medicoLegalCase: medicoLegalCase,
        },
        caseDetails?.id,
      );
      await fetchCaseDetails();
      setIsEditMode(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    toast.success("Admission Details Data Updated");
  };
  useEffect(() => {
    if (!caseDetails) return;

    const formatDate = (dateString) => {
      if (!dateString) return "";

      return new Date(dateString).toLocaleDateString("en-GB");
    };

    setAdmissionDate(formatDate(caseDetails?.admissionDate));

    setAdmissionTime(extractISTTimeFromUTC(caseDetails?.admissionDate));
    setDischargeDate(formatDate(caseDetails?.surgeryTreatmentStartDate));

    setAdmissionType(caseDetails?.admissionType || "");

    setMedicoLegalCase(
      caseDetails?.medicoLegalCase?.toLowerCase() === "yes" ? "Yes" : "No",
    );

    setIncidentDate(formatDate(caseDetails?.incidentDate));

    setFirDate(formatDate(caseDetails?.firDate));

    setDescription(caseDetails?.authenticationConsent || "");

    setHospitalName(caseDetails?.hospital?.name || "");
  }, [caseDetails]);
  useEffect(() => {
    if (saveAll && isEditMode) {
      handleUpdate();
    }
  }, [saveAll]);
  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="grid grid-cols-3 2xl:grid-cols-4 gap-[6px] 2xl:gap-[4px] 3xl:gap-3 pt-[30px]">
        {/* Admission Date */}
        <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[18px] flex items-center">
          <div className="flex items-center gap-[8px]">
            {isEditMode ? (
              <input
                ref={admissionDateRef}
                type="date"
                value={admissionDate}
                min={getMinDate()}
                max={getMaxDate()}
                onChange={(e) => setAdmissionDate(e.target.value)}
                className="bg-transparent border-none outline-none appearance-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000]"
              />
            ) : (
              <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000] whitespace-nowrap">
                {admissionDate || "DD/MM/YYYY"}
              </span>
            )}

            {admissionDate && (
              <span className="font-lufga font-normal 2xl:pl-8 3xl:pl-14 text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]">
                Admission Date
              </span>
            )}
          </div>

          <div
            className="ml-auto flex items-center cursor-pointer"
            onClick={() => {
              if (isEditMode) {
                admissionDateRef.current?.showPicker?.();
              }
            }}
          >
            <img
              src={calenderIcon}
              alt="calender icon"
              width={16}
              height={16}
            />
          </div>
        </div>

        {/* Admission Time */}
        <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[18px] flex items-center">
          <div className="flex items-center gap-[8px]">
            {isEditMode ? (
              <input
                type="time"
                value={admissionTime}
                onChange={(e) => setAdmissionTime(e.target.value)}
                className="bg-transparent border-none outline-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000]"
              />
            ) : (
              <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000] whitespace-nowrap">
                {admissionTime || "Select Time"}
              </span>
            )}

            <span className="font-lufga font-normal text-[12px] pl-14 leading-[12px] tracking-[-0.03em] text-[#8B8B8B]">
              Admission Time
            </span>
          </div>

          <div className="ml-auto flex items-center cursor-pointer">
            <img src={timeIcon} alt="calender icon" w="16px" h="16px" />
          </div>
        </div>

        {/* Discharge Date */}
        <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[18px] flex items-center">
          <div className="flex items-center gap-[8px]">
            {isEditMode ? (
              <input
                type="date"
                value={dischargeDate}
                ref={surgeryTreatmentDateRef}
                onChange={(e) => setDischargeDate(e.target.value)}
                className="bg-transparent border-none outline-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000]"
              />
            ) : (
              <span>{dischargeDate || "DD/MM/YYYY"}</span>
            )}
          </div>

          <div className="ml-auto flex items-center cursor-pointer">
            <span className="font-lufga font-normal pl-12 3xl:pl-14 text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]">
              Surgery Treatment Date
            </span>
            <img
              src={calenderIcon}
              alt="calender icon"
              w="16px"
              h="16px"
              onClick={() => {
                if (isEditMode) {
                  surgeryTreatmentDateRef.current?.showPicker?.();
                }
              }}
            />
          </div>
        </div>

        {/* Admission Type */}
        <div className="relative w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
          <select
            value={admissionType}
            disabled={!isEditMode}
            onChange={(e) => setAdmissionType(e.target.value)}
            className="absolute inset-0 w-full h-full pl-[32px] pr-[50px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000]"
          >
            {admissionTypeOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          {admissionType && (
            <span className="absolute right-[50px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
              Admission Type
            </span>
          )}

          <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M7 10.5L14 17.5L21 10.5"
                stroke="#5AC69F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Medico Legal Case */}
        <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] pl-[14px] pr-[4px] flex items-center">
          <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] whitespace-nowrap">
            Medico Legal Case
          </span>

          <div className="ml-auto flex items-center gap-[2px]">
            <button
              disabled={!isEditMode}
              onClick={() => setMedicoLegalCase("Yes")}
              className={`w-[66px] h-[41px] rounded-[100px] flex justify-center items-center font-lufga font-normal text-[14px] border border-none leading-[12px] tracking-[-0.03em] ${
                medicoLegalCase === "Yes"
                  ? "bg-[#5AC69F] text-white"
                  : "bg-[#F5F5F5] text-[#000000]"
              }`}
            >
              Yes
            </button>

            <button
              disabled={!isEditMode}
              onClick={() => setMedicoLegalCase("No")}
              className={`w-[66px] h-[41px] rounded-[100px] flex justify-center border border-none items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] ${
                medicoLegalCase === "No"
                  ? "bg-[#FF4343] text-white"
                  : "bg-[#F5F5F5] text-[#000000]"
              }`}
            >
              No
            </button>
          </div>
        </div>

        {medicoLegalCase === "Yes" && (
          <>
            {/* Row 2 */}
            <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px] 3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[18px] flex items-center">
              <div className="flex items-center gap-[8px]">
                {isEditMode ? (
                  <input
                    ref={incidentDateRef}
                    type="date"
                    value={incidentDate}
                    onChange={(e) => setIncidentDate(e.target.value)}
                    className="bg-transparent border-none outline-none appearance-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000]"
                  />
                ) : (
                  <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000] whitespace-nowrap">
                    {incidentDate || "DD/MM/YYYY"}
                  </span>
                )}

                <span className="font-lufga font-normal 2xl:pl-8 3xl:pl-14 text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]">
                  Incident Date
                </span>
              </div>

              <div
                className="ml-auto flex items-center cursor-pointer"
                onClick={() => {
                  if (isEditMode) {
                    incidentDateRef.current?.showPicker?.();
                  }
                }}
              >
                <img
                  src={calenderIcon}
                  alt="calender icon"
                  width={16}
                  height={16}
                />
              </div>
            </div>

            <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px] 3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[18px] flex items-center">
              <div className="flex items-center gap-[8px]">
                {isEditMode ? (
                  <input
                    ref={firDateRef}
                    type="date"
                    value={firDate}
                    onChange={(e) => setFirDate(e.target.value)}
                    className="bg-transparent border-none outline-none appearance-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000]"
                  />
                ) : (
                  <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#000000] whitespace-nowrap">
                    {firDate || "DD/MM/YYYY"}
                  </span>
                )}

                <span className="font-lufga font-normal 2xl:pl-8 3xl:pl-14 text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]">
                  FIR Date
                </span>
              </div>

              <div
                className="ml-auto flex items-center cursor-pointer"
                onClick={() => {
                  if (isEditMode) {
                    firDateRef.current?.showPicker?.();
                  }
                }}
              >
                <img
                  src={calenderIcon}
                  alt="calender icon"
                  width={16}
                  height={16}
                />
              </div>
            </div>

            <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[32px] flex items-center">
              <input
                type="text"
                placeholder="Hospital Name"
                value={hospitalName}
                onChange={(e) => setHospitalName(e.target.value)}
                className="w-full bg-transparent border-none outline-none focus:outline-none focus:ring-0 shadow-none font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] placeholder:text-[#8B8B8B]"
              />
            </div>

            {/* Row 3 */}
            <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[18px] flex items-center">
              <input
                disabled={!isEditMode}
                type="file"
                onChange={(e) => setFirReport(e.target.files[0])}
                className="hidden"
                id="firReport"
              />

              <label
                htmlFor="firReport"
                className={`w-full flex items-center justify-between font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] ${
                  !isEditMode
                    ? "pointer-events-none opacity-60"
                    : "cursor-pointer"
                }`}
              >
                <span>{firReport ? firReport.name : "Upload FIR report"}</span>

                <img src={uplaodIcon} alt="upload icon" />
              </label>
            </div>

            <div className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px]  3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[18px] flex items-center">
              <input
                disabled={!isEditMode}
                type="file"
                onChange={(e) =>
                  setSuperintendentDeclaration(e.target.files[0])
                }
                className="hidden"
                id="superintendentDeclaration"
              />

              <label
                htmlFor="superintendentDeclaration"
                className={`w-full flex items-center justify-between font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] ${
                  !isEditMode
                    ? "pointer-events-none opacity-60"
                    : "cursor-pointer"
                }`}
              >
                <span>
                  {superintendentDeclaration
                    ? superintendentDeclaration.name
                    : "Upload Superintendent Declaration"}
                </span>

                <img src={uplaodIcon} alt="upload icon" />
              </label>
            </div>

            <div className="col-span-2 xl:col-span-2 xl:w-[710px] xl:h-[52px] 2xl:w-[632px] 3xl:w-[770px] h-[90px] 2xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[32px] flex items-center">
              <input
                type="text"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full bg-transparent border-none outline-none focus:outline-none focus:ring-0 shadow-none font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] placeholder:text-[#8B8B8B]"
              />
            </div>
          </>
        )}
      </div>
      {!location?.pathname?.toLowerCase()?.includes("editcases") && (
        <div>
          {isEditMode ? (
            <div className="flex justify-end mt-[12px]">
              <button
                className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px] 2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal"
                onClick={handleUpdate}
                // disabled={isSubmitting}
              >
                SAVE
                <img src={saveIcon} alt="save" className="pl-[16px]" />
              </button>
            </div>
          ) : (
            <div className="flex justify-end items-center gap-[10px] mt-[12px]">
              <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
                SAVED
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13L9 17L19 7"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <button
                onClick={() => setIsEditMode(true)}
                className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent"
              >
                <img src={editIcon} alt="edit icon" width={9} height={18} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdmissionDetailsForm;
